export const IconImg = {
  Book: require("../assets/icon/book.svg").ReactComponent,
  Histogram: require("../assets/icon/histogram.svg").ReactComponent,
  Map: require("../assets/icon/map.svg").ReactComponent,
  Network: require("../assets/icon/network.svg").ReactComponent,
  Company: require("../assets/icon/company.svg").ReactComponent,
  CaretDown: require("../assets/icon/caret-down.svg").ReactComponent,
  Calendar: require("../assets/icon/calendar.svg").ReactComponent,
  FloppyDist: require("../assets/icon/floppy-disk.svg").ReactComponent,
  Close: require("../assets/icon/close.svg").ReactComponent,
};
